module.exports = __webpack_public_path__ + "media/images/lb/994-27bb61b0a68639ce506ff032d4ebe577.svg";